import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { CommPlan } from 'src/app/models/commission/comm-plan.model';
import { CommissionService } from 'src/app/service/commission.service';
import { NotificationService } from 'src/app/service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
@Component({
  selector: 'app-replicate-plan',
  templateUrl: './replicate-plan.component.html',
  styleUrls: ['./replicate-plan.component.css']
})
export class ReplicatePlanComponent implements OnInit {
  commModel = new CommPlan();
  salesChannels: string[];
  flags:string[] =['Y','N'];

  constructor(private commissionService: CommissionService,
    private router: Router, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.commModel = this.commissionService.commModel
    this.salesChannels = this.commissionService.salesChannels;
    console.log(this.commModel);
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

 }
